package app.nestbridge.feature.common.presentation

import app.nestbridge.feature.common.screen.DocumentViewerScreen
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import com.slack.circuit.runtime.screen.Screen
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
@Origin(DocumentViewerPresenter::class)
public class DocumentViewerPresenterFactory(
  private val factory:
      (screen: DocumentViewerScreen, navigator: Navigator) -> DocumentViewerPresenter,
) : Presenter.Factory {
  override fun create(
    screen: Screen,
    navigator: Navigator,
    context: CircuitContext,
  ): Presenter<*>? = when (screen) {
    is DocumentViewerScreen -> factory(screen, navigator)
    else -> null
  }
}
